import React, {useContext, useEffect} from "react";
import { NavLink} from 'react-router-dom';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import {Loading} from '../custom/LoadingComponent'
import ClientSubconFullRenderer from './ClientSubconFullRendererComponent';
import BucketContext from "../context/BucketContext";
import * as Security from '../../utils/auth/Security';
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

const ClientSubconManagement = (props) => {
    console.log('___Client Subcontractor Management___');

    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        props.loadComponentData(props.client.id);

        if(bucketContext.bucket.mostRecentClientSubconId != null) {
            console.log('Reseting the mostRecentClientSubconId: ' + JSON.stringify(bucketContext.bucket.mostRecentClientSubconId));
            bucketContext.setBucketValue({mostRecentClientSubconId: null});
        }
    }, [props.client]);


    const getClientName = (clientId) => {
        var clientName = '';

        const client = props.clients.find( (client) => client.id === clientId );
        if(client) {
            clientName = client.generalSection.clientName;
        }

        return clientName;
    }

    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else if(props.subcontractor != null) {

        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            {Security.isUserAuthorizedForPath('/clients') ?
                                <NavLink to={`/clients/${props.client.id}`}>{props.client.generalSection.clientName}</NavLink>
                                    :
                                <NavLink to='/myclient'>{props.client.generalSection.clientName}</NavLink>
                            }
                            <Typography color="text.primary">{getClientName(props.subcontractor.generalSection.clientId)} [Subcontractor]</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <h3>{getClientName(props.subcontractor.generalSection.clientId)}</h3>
                    </Box>
                    <hr/>

                    <ClientSubconFullRenderer 
                        subcontractor={props.subcontractor} 
                        saveSubcontractor={props.patchSubcontractor} 
                        clients={props.clients}
                        employers={props.employers}
                        worksites={props.worksites}    
                    />

                </Stack>

            </Box>
            </Container>
        );
    } else {
        console.log('Here Here....')

        return(
            <div></div>
        );
    }

}


export default ClientSubconManagement